import React, { useState } from 'react';
import FormInput from '../components/ui/FormInput';
import Button from '../components/ui/Button';
import { CheckCircleIcon, ArrowRightIcon } from 'lucide-react';
const Quote = () => {
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    interestedIn: '',
    comments: ''
  });
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    setFormSubmitted(true);
  };
  const insuranceOptions = [{
    value: 'life',
    label: 'Life Insurance'
  }, {
    value: 'auto',
    label: 'Auto Insurance'
  }, {
    value: 'home',
    label: 'Home Insurance'
  }, {
    value: 'business',
    label: 'Business Insurance'
  }, {
    value: 'health',
    label: 'Health Insurance'
  }, {
    value: 'umbrella',
    label: 'Umbrella Insurance'
  }, {
    value: 'travel',
    label: 'Travel Insurance'
  }, {
    value: 'renters',
    label: 'Renters Insurance'
  }, {
    value: 'multiple',
    label: 'Multiple Policies'
  }];
  return <div className="w-full bg-secondary pt-24" data-id="element-513">
      {/* Page Header */}
      <section className="bg-gradient-gold py-20 relative overflow-hidden" data-id="element-514">
        <div className="absolute inset-0 opacity-10" style={{
        backgroundImage: "url('data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23D4AF37' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E')"
      }} data-id="element-515"></div>
        <div className="container mx-auto px-4 relative z-10 text-center" data-id="element-516">
          <h1 className="text-text-primary font-display font-black mb-4 text-4xl md:text-5xl tracking-widest" data-id="element-517">
            GET IN TOUCH WITH US
          </h1>
          <p className="text-text-secondary max-w-2xl mx-auto font-body text-lg" data-id="element-518">
            Complete the form below and one of our advisors will contact you
            within 24 hours.
          </p>
        </div>
      </section>

      {/* Quote Form Section */}
      <section className="py-20 bg-background" data-id="element-519">
        <div className="container mx-auto px-4" data-id="element-520">
          <div className="max-w-2xl mx-auto gradient-border p-10 hover:shadow-gold-md transition-all duration-300" data-id="element-521">
            {formSubmitted ? <div className="text-center" data-id="element-522">
                <div className="w-20 h-20 bg-primary/20 rounded-full flex items-center justify-center mx-auto mb-8" data-id="element-523">
                  <CheckCircleIcon size={48} className="text-primary" data-id="element-524" />
                </div>
                <h2 className="text-text-primary font-display font-bold mb-4 text-2xl tracking-wide" data-id="element-525">
                  THANK YOU!
                </h2>
                <p className="text-text-secondary mb-8 leading-relaxed font-body" data-id="element-526">
                  Your request has been successfully submitted. One of our
                  advisors will contact you within 24 hours to discuss your
                  needs and provide personalized recommendations.
                </p>
                <Button href="/" variant="secondary" className="group" data-id="element-527">
                  RETURN TO HOME
                  <ArrowRightIcon size={16} className="ml-2 group-hover:translate-x-1 transition-transform duration-200" data-id="element-528" />
                </Button>
              </div> : <>
                <div className="text-center mb-10" data-id="element-529">
                  <h2 className="text-text-primary font-display font-bold mb-4 text-2xl tracking-wide" data-id="element-530">
                    REQUEST A CONSULTATION
                  </h2>
                  <p className="text-text-secondary leading-relaxed font-body" data-id="element-531">
                    Please provide your information below, and we'll schedule a
                    personalized consultation to discuss your specific needs and
                    objectives.
                  </p>
                </div>
                <form onSubmit={handleSubmit} className="space-y-6" data-id="element-532">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-533">
                    <FormInput label="FIRST NAME" name="firstName" required value={formData.firstName} onChange={handleChange} data-id="element-534" />
                    <FormInput label="LAST NAME" name="lastName" required value={formData.lastName} onChange={handleChange} data-id="element-535" />
                  </div>
                  <FormInput label="EMAIL ADDRESS" type="email" name="email" required value={formData.email} onChange={handleChange} data-id="element-536" />
                  <FormInput label="PHONE NUMBER" type="tel" name="phone" required value={formData.phone} onChange={handleChange} data-id="element-537" />
                  <FormInput label="INTERESTED IN" type="select" name="interestedIn" required options={insuranceOptions} value={formData.interestedIn} onChange={handleChange} data-id="element-538" />
                  <FormInput label="ADDITIONAL INFORMATION" type="textarea" name="comments" placeholder="Please provide any specific details about your needs or questions..." value={formData.comments} onChange={handleChange} data-id="element-539" />
                  <div className="pt-4" data-id="element-540">
                    <Button type="submit" className="w-full py-4" data-id="element-541">
                      SUBMIT REQUEST
                    </Button>
                  </div>
                  <p className="text-xs text-text-secondary/60 mt-4 text-center font-body" data-id="element-542">
                    By submitting this form, you agree to our Privacy Policy and
                    consent to being contacted regarding our services. We
                    respect your privacy and will never sell your information to
                    third parties.
                  </p>
                </form>
              </>}
          </div>
        </div>
      </section>
    </div>;
};
export default Quote;